// -----------------------------
// Style Upsell Images
// -----------------------------
function styleSectionStoreUpsellImages() {
  const upsellBlocks = document.querySelectorAll('section-store--upsell-block');
  upsellBlocks.forEach(block => {
    if (!block.shadowRoot) return;
    const shadow = block.shadowRoot; 
    const body = shadow.querySelector('.body');
    if (!body) return;
    const upsellList = body.querySelector('.upsell-list');
    if (!upsellList) return;

    const boxes = upsellList.querySelectorAll('.upsell-box');
    boxes.forEach(box => {
      const img = box.querySelector('img.product-image');
      if (img && !img.dataset.borderAdded) {
        img.style.border = '1px solid #7CA0C5';
        img.style.borderRadius = '4px';
        img.style.objectFit = 'cover';
        img.style.overflow = 'hidden';
        img.dataset.borderAdded = 'true';
      }
    });
  });
}
function reloadAfterUpsell() {
  const upsellBlocks = document.querySelectorAll('section-store--upsell-block');

  upsellBlocks.forEach(block => {
    if (!block.shadowRoot) return;
    const shadow = block.shadowRoot;
    const body = shadow.querySelector('.body');
    if (!body) return;

    const upsellBoxes = body.querySelectorAll('.upsell-box');
    upsellBoxes.forEach(box => {
      const button = box.querySelector('.add-to-cart button');
      if (!button) return;

      if (button.dataset.reloadListenerAttached) return;
      button.dataset.reloadListenerAttached = 'true';

      button.addEventListener('click', () => {
        console.log('Upsell button clicked — waiting for cart update...');

        // Watch for the cart to change (Shopify cart API)
        const cartObserver = new MutationObserver(() => {
          console.log('Cart updated — reloading page!');
          window.location.reload();
          cartObserver.disconnect();
        });

        // Target the element the app updates — usually the drawer or cart counter
        const cartContainer = document.querySelector('component-panel[data-sub-id="quickCart"]') ||
                              document.querySelector('[data-cart-count]');
        if (cartContainer) {
          cartObserver.observe(cartContainer, { childList: true, subtree: true });
        } else {
          // fallback if we can't find cart container
          setTimeout(() => window.location.reload(), 1000);
        }
      });
    });
  });
}

// Initial run
reloadAfterUpsell();

// Observe dynamically added upsell blocks
new MutationObserver(() => reloadAfterUpsell()).observe(document.body, { childList: true, subtree: true });


// window._upsellLocks = window._upsellLocks || {};

// async function refreshQuickCartDrawer() {
//   try {
//     const cartRes = await fetch('/cart.js');
//     const cart = await cartRes.json();
//     window._currentCart = cart;

//     if (window.componentPanels?.quickCart?.refresh) {
//       window.componentPanels.quickCart.refresh();
//       window.componentPanels.quickCart.open();
//     } else {
//       document.dispatchEvent(new CustomEvent('theme-cart:updated', { detail: { shouldOpenCart: true } }));
//     }
//   } catch (err) {
//     console.error('Error refreshing quick cart:', err);
//   }
// }

// function attachUpsellAddButtons() {
//   const upsellBlocks = document.querySelectorAll('section-store--upsell-block');

//   upsellBlocks.forEach(block => {
//     if (!block.shadowRoot) return;

//     const shadow = block.shadowRoot;
//     const body = shadow.querySelector('.body');
//     if (!body) return;

//     const upsellList = body.querySelector('.upsell-list');
//     if (!upsellList) return;

//     const boxes = upsellList.querySelectorAll('.upsell-box');

//     boxes.forEach(box => {
//       const button = box.querySelector('.add-to-cart button');
//       if (!button || button.dataset.listenerAttached === 'true') return;

//       button.dataset.listenerAttached = 'true';

//       button.addEventListener('click', async e => {
//         e.preventDefault();
//         const variantId = button.dataset.variantId;
//         if (!variantId) return console.warn('No variant ID');

//         if (window._upsellLocks[variantId]) return;

//         window._upsellLocks[variantId] = true;
//         button.disabled = true;
//         button.classList.add('loading');

//         try {
//           await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: variantId, quantity: 1 })
//           });
//           await refreshQuickCartDrawer();
//         } catch (err) {
//           console.error('Upsell add-to-cart error:', err);
//         } finally {
//           button.classList.remove('loading');
//           button.disabled = false;
//           window._upsellLocks[variantId] = false;
//         }
//       });
//     });
//   });
// }

// let attachTimeout;
// new MutationObserver(() => {
//   clearTimeout(attachTimeout);
//   attachTimeout = setTimeout(attachUpsellAddButtons, 100);
// }).observe(document.body, { childList: true, subtree: true });


function updateStockText() {
  const stockBlocks = document.querySelectorAll('section-store--pulse-badge-block');

  // Translation strings
  const translations = {
    en: {
      inStock: 'Order before 21:30, shipped by tomorrow',
      outOfStock: 'Not in Stock'
    },
    nl: {
      inStock: 'Bestel voor 21:30, morgen verzonden',
      outOfStock: 'Niet op voorraad'
    },
    fr: {
      inStock: 'Commandez avant 21h30, expédié demain',
      outOfStock: 'Rupture de stock'
    }
    // add more languages if needed
  };

  stockBlocks.forEach(block => {
    if (!block.shadowRoot) return;
    const shadow = block.shadowRoot;
    const body = shadow.querySelector('.body');
    if (!body) return;
    const content = body.querySelector('.content');
    if (!content) return;

    const textEl = content.querySelector('.text p');
    const iconEl = content.querySelector('.icon'); // target the pulse icon
    if (!textEl) return;

    // Get the JSON of the selected variant
    const variantJSON = document.querySelector(
      'component-product-variant-selectors script[type="application/json"]'
    );

    let isInStock = false;

    if (variantJSON) {
      try {
        const variant = JSON.parse(variantJSON.textContent);
        if (variant && typeof variant.available !== 'undefined') {
          isInStock = Boolean(variant.available);
        }
      } catch (e) {
        console.error('Error parsing selected variant JSON:', e);
      }
    }

    // Determine page language
    const userLang = document.documentElement.lang || 'en';
    const lang = translations[userLang] ? userLang : 'en';

    // Update the stock text and icon color
    if (isInStock) {
      content.style.display = 'flex';
      textEl.textContent = translations[lang].inStock; // translated text
      textEl.style.color = '#008060'; // green text
      if (iconEl) iconEl.style.setProperty('--icon-color', '#008060'); // green pulse

      // Show shipping info (outer wrapper)
      const shippingWrapper = document.querySelector('section-store--shipping-info-block')?.closest('.shopify-block.shopify-app-block');
      if (shippingWrapper) shippingWrapper.style.display = 'block';
    } else {
      content.style.display = 'flex';
      textEl.textContent = translations[lang].outOfStock; // translated text
      textEl.style.color = 'red'; // red text
      if (iconEl) iconEl.style.setProperty('--icon-color', 'red'); // red pulse

      // Hide shipping info (outer wrapper)
      const shippingWrapper = document.querySelector('section-store--shipping-info-block')?.closest('.shopify-block.shopify-app-block');
      if (shippingWrapper) shippingWrapper.style.display = 'none';
    }
  });
}


// -----------------------------
// Initialize Everything
// -----------------------------
function initUpsellAndStock() {
  styleSectionStoreUpsellImages();
  updateStockText();

  // Observe dynamically added upsell and stock blocks
  new MutationObserver(() => {
    styleSectionStoreUpsellImages();
    updateStockText();
  }).observe(document.body, { childList: true, subtree: true });

  // Listen to changes on swatches/radios
  document.querySelectorAll('input[name^="options["]').forEach(input => {
    input.addEventListener('change', updateStockText);
  });

  // Optional: also observe the <script> tag in case theme replaces it dynamically
  const variantScript = document.querySelector(
    'component-product-variant-selectors script[type="application/json"]'
  );
  if (variantScript) {
    new MutationObserver(updateStockText).observe(variantScript, {
      childList: true
    });
  }
}

// Run
initUpsellAndStock();


// -----------------------------
// Sticky Add-to-Cart Fix (Quantity Fixed)
// -----------------------------
function initStickyAddToCart() {
  // Find all sticky add-to-cart buttons
  const stickyButtons = document.querySelectorAll('[data-essential-cart-element="add-to-cart-button"]');

  stickyButtons.forEach(btn => {
    // Skip duplicates
    if (btn.dataset.listenerAdded === 'true') return;
    btn.dataset.listenerAdded = 'true';

    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Sticky add-to-cart clicked');

      // Find the form
      const form = btn.closest('[data-essential-cart-element="essential-sticky-add-to-cart-form"]') || btn.form;
      if (!form) return;
      console.log('Form found: ', form);

      // Get variant ID
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;
      const variantId = variantInput.value;
      console.log('Variant ID: ', variantId);

      // --- FIXED QUANTITY ---
      // Find quantity relative to sticky drawer
      const quantityWrapper = btn.closest('[data-essential-cart-element="content-container-desktop"]')
                               ?.querySelector('[data-essential-cart-element="quantity-select-inner"]');

      const quantitySpan = quantityWrapper?.querySelector('span');
      const quantity = quantitySpan ? parseInt(quantitySpan.textContent.trim(), 10) : 1;
      console.log('Quantity selected:', quantity);

      try {
        // Fetch current cart
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        // Check if this variant already exists
        const existingIndex = cart.items.findIndex(item => item.id == variantId);

        if (existingIndex !== -1) {
          // Update existing line item quantity
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: existingIndex + 1,
              quantity: cart.items[existingIndex].quantity + quantity
            })
          });
        } else {
          // Add new item
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity })
          });
        }

        console.log('Sticky add-to-cart: success');

        // Reload page to reflect changes
        window.location.reload();
      } catch (err) {
        console.error('Sticky add-to-cart error:', err);
      }
    }, { capture: true });
  });
}

// Initialize now and watch for dynamically added buttons
initStickyAddToCart();
new MutationObserver(initStickyAddToCart).observe(document.body, { childList: true, subtree: true });



// -----------------------------
// Upsell Variant Image Debug + Updater
// -----------------------------
document.addEventListener('DOMContentLoaded', () => {
  // Watch for upsell blocks
  const upsellObserver = new MutationObserver((mutations) => {
    const upsellBlocks = document.querySelectorAll('section-store--upsell-block');

    upsellBlocks.forEach(block => {
      if (!block.shadowRoot) return;
      const shadow = block.shadowRoot;

      // Only attach once
      if (shadow.dataset.listenerAttached) return;
      shadow.dataset.listenerAttached = 'true';

      console.log('ShadowRoot found for upsell block');

      // Watch inside shadowRoot for .option elements
      const optionObserver = new MutationObserver(() => {
        const options = shadow.querySelectorAll('.option');

        options.forEach(option => {
          // Only attach once per option
          if (option.dataset.listenerAttached) return;
          option.dataset.listenerAttached = 'true';

          option.addEventListener('click', async () => {
            console.log('Clicked option inside shadowRoot:', option);

            const variantId = option.dataset.variantId;
            const productBlock = option.closest('section-store--upsell-block--selector-options');
            const productId = productBlock?.dataset.productId;

            console.log('Variant ID:', variantId, 'Product ID:', productId);

            if (!variantId || !productId) return;

            try {
              // Fetch product JSON dynamically
              const res = await fetch(`/products/${productId}.js`);
              const product = await res.json();

              const variant = product.variants.find(v => String(v.id) === String(variantId));
              if (!variant) return console.warn('Variant not found');

              const imgUrl = variant.featured_image?.src || product.featured_image?.src;
              if (!imgUrl) return console.warn('No image for this variant');

              const upsellBox = option.closest('.upsell-box');
              const img = upsellBox?.querySelector('img.product-image');
              if (!img) return console.warn('Upsell image element not found');

              console.log('Updating image to:', imgUrl);

              img.style.transition = 'opacity 0.15s';
              img.style.opacity = 0;
              setTimeout(() => {
                img.src = imgUrl;
                img.style.opacity = 1;
              }, 120);

            } catch (err) {
              console.error('Error fetching product JSON:', err);
            }
          });
        });
      });

      optionObserver.observe(shadow, { childList: true, subtree: true });
    });
  });

  upsellObserver.observe(document.body, { childList: true, subtree: true });
});
